// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__UuScw","containerLogo":"footer_containerLogo__jxzAB","containerText":"footer_containerText___Lm4_","containerLinks":"footer_containerLinks__i6gEn"};